import { Component, input } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'wci-button',
    imports: [NgClass, RouterLink, NgTemplateOutlet],
    template: `
        <ng-template #btnContent>
            @if (variant() == 'primary') {
                <span class="relative flex size-3">
                    <span
                        class="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-200 opacity-75"></span>
                    <span class="relative inline-flex size-3 rounded-full bg-green-300"></span>
                </span>
            }

            <span><ng-content></ng-content></span>

            @if (variant() !== 'stacked') {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" class="h-6">
                    <line
                        x1="40"
                        y1="128"
                        x2="216"
                        y2="128"
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="16" />
                    <polyline
                        points="144 56 216 128 144 200"
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="16" />
                </svg>
            }
        </ng-template>

        @if (href()) {
            <a
                [ngClass]="classNames"
                [attr.aria-label]="label()"
                [href]="href() || undefined"
                [target]="target() || undefined">
                <ng-container *ngTemplateOutlet="btnContent"></ng-container>
            </a>
        } @else {
            <a
                [ngClass]="classNames"
                [attr.aria-label]="label()"
                [routerLink]="routerLink() || undefined">
                <ng-container *ngTemplateOutlet="btnContent"></ng-container>
            </a>
        }
    `,
    styles: ``,
})
export class ButtonComponent {
    href = input<string>();
    target = input<string>();
    routerLink = input<string>();

    variant = input<'primary' | 'secondary' | 'stacked'>('primary');
    label = input.required<string>();
    buttonClass = input<string>('');

    get classNames(): string[] {
        const baseClasses = ['btn'];
        const render = [...baseClasses, this.buttonClass()];

        if (this.variant()) {
            render.push(`${this.variant()}`);
        }

        return render;
    }
}
